function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classNames from 'classnames';
import Types from 'prop-types';
import requiredIf from 'react-required-if';
import Dropdown from '../Dropdown';
import DropdownItem from './DropdownItem';
var CardDropdown = function CardDropdown(_ref) {
  var itemId = _ref.itemId,
    isOpen = _ref.isOpen,
    items = _ref.items,
    mainCTA = _ref.mainCTA,
    activePath = _ref.activePath,
    onCloseMenu = _ref.onCloseMenu;
  return /*#__PURE__*/React.createElement(Dropdown, {
    className: classNames({
      hidden: !isOpen
    })
  }, /*#__PURE__*/React.createElement(DropdownItem, _extends({
    className: "tw-public-nav__dropdown-cta item"
  }, mainCTA, {
    itemId: itemId,
    activePath: activePath
  })), items.map(function (item) {
    return /*#__PURE__*/React.createElement(DropdownItem, _extends({}, item, {
      className: "item",
      itemId: itemId,
      titleTranslationKey: item.translationKey,
      titleTranslatedText: item.translatedText,
      activePath: activePath,
      key: item.translationKey || item.translatedText,
      onCloseMenu: onCloseMenu
    }));
  }));
};
CardDropdown.defaultProps = {
  activePath: undefined,
  isOpen: false,
  onToggle: function onToggle() {},
  onCloseMenu: function onCloseMenu() {},
  itemId: ''
};
export default CardDropdown;